<template>
  <v-row no-gutters>
    <v-col cols="8">
      <v-list-item>
        <v-list-item-icon>
          <v-icon v-if="icon && clickableIcon" size="32" @click="popup = true">{{ icon }}</v-icon>
          <v-icon v-else size="32">{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle>{{ title }}</v-list-item-subtitle>
          <v-list-item-title v-if="newValue" class="mt-2">{{ formatDate(newValue) }} </v-list-item-title>
          <v-list-item-title v-else>--</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col v-if="!readonly" cols="4" align-self="center" class="d-flex justify-center">
      <v-row
        align="center"
        justify="end"
        no-gutters
      >
        <v-btn v-if="selectEndDate" class="black--text justify-end" plain rounded @click="popup = true">
          <v-icon color="black">mdi-plus</v-icon>
        </v-btn>

        <v-overlay
          :value="popup"
          opacity="0.5"
        >
          <v-card
            light
          >
            <v-container class="px-2">
              <v-card-title class="full-width">
                <span class="d-flex justify-center flex-grow-1">{{ title }}</span>
                <v-icon size="28" color="third" class="justify-end" @click="closeOverlay">mdi-close</v-icon>
              </v-card-title>

              <v-card-text>
                <v-date-picker
                  v-model="newValue"
                  color="third"
                  :min="minDate"
                  :max="maxDate"
                  @click:date="closeOverlay"
                />
              </v-card-text>
            </v-container>
          </v-card>
        </v-overlay>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import { getUnixTime, parseISO, format } from 'date-fns';

export default {
  props: {
    value: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    },
    readonly: { type: Boolean },
    icon: {
      type: String,
      default: null
    },
    selectEndDate: {
      type: Boolean,
      default: true
    },
    clickableIcon: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const popup = ref(false);
    const date = props.value ? format(new Date(props.value * 1000), 'yyyy-MM-dd') : null;
    const newValue = ref(date);

    // v-model
    watch(newValue, () => {
      // convert to unix
      const unixDate = getUnixTime(new Date(parseISO(newValue.value)));
      context.emit('input', unixDate);
    });

    watch(() => props.value, () => {
      // convert to date
      newValue.value = props.value ? format(new Date(props.value * 1000), 'yyyy-MM-dd') : props.value;
    });

    const closeOverlay = () => {
      popup.value = false;
    };

    const formatDate = receivedDate => {
      try {
        return format(new Date(receivedDate * 1000), 'dd/MM/yyyy');
      } catch (ex) {
        return format(new Date(parseISO(receivedDate)), 'dd/MM/yyyy');
      }
    };

    return { popup, closeOverlay, newValue, formatDate };
  }
};
</script>
